// extracted by mini-css-extract-plugin
export default {"error":"error__Zodlexks","errorImg":"errorImg__upJDt3AM","title":"title__NCqukujk"};